import React, { useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { useSelector, useDispatch } from 'react-redux';
import { setDrawerOpen } from '@/state/user';
import { Image } from 'expo-image';

const styles = StyleSheet.create({
  lightningIcon: {
    width: 13,
    height: 13,
    marginVertical: 10,
    marginHorizontal: 20,
  },
});

type Props = {
  flag?: boolean,
};

export default function DrawerButton({ flag = true }: Props) : React.ReactNode {
  const dispatch = useDispatch();

  return (
    <Pressable onPress={() => dispatch(setDrawerOpen(true)) } hitSlop={20}>
      <Image
        style={styles.lightningIcon}
        source={require('@/assets/images/lightning2.png')}
      />
    </Pressable>
  );
};
